// ============================================
// LAYER 1: Base Configuration Templates
// ============================================

export const CONFIG_TEMPLATES = {
  // For attorneys and legal services


  // For hotels, motels, stays, rental agencies
  hospitality: {
    ratingCategories: [
      { key: "overAllRating", label: "Over All Rating" },
      { key: "roomRating", label: "Rooms" },
      { key: "serviceRating", label: "Service" },
      { key: "locationRating", label: "Location" }
    ],
    detailSections: [
      "Rooms",
      "Nearby activities",
      "Safety",
      "Walkability",
      "Food & drinks",
      "Noteworthy details"
    ],
    tripTypeQuestion: "What kind of trip was it?",
    tripTypeOptions: ["Business", "Vacation"],
    travelWithQuestion: "Who did you travel with?",
    travelWithOptions: ["Family", "Friends", "Couple", "Solo"],
    descriptionQuestion: "How would you describe the place?",
    descriptionOptions: ["Luxury", "Great view", "Romantic", "Quiet", "Kid-friendly", "Great value", "High-tech"],
    commentPlaceholder: "Share details of your own experience at this place"
  },


  // For restaurants, cafes, bakeries, food places
  restaurant: {
    ratingCategories: [
      { key: "overAllRating", label: "Over All Rating" },
      { key: "foodRating", label: "Food" },
      { key: "serviceRating", label: "Service" },
      { key: "ambienceRating", label: "Atmosphere" }
    ],
    detailSections: [
      "Vegetarian options",
      "Dietary restrictions",
      "Parking",
      "Kid-friendliness",
      "Wheelchair accessibility"
    ],
    tripTypeQuestion: "What did you get?",
    tripTypeOptions: ["Breakfast", "Brunch", "Lunch", "Dinner", "Other"],
    travelWithQuestion: "How much did you spend per person?",
    travelWithOptions: ["$1-10", "$10-20", "$20-30", "$30-50", "$50-100", "$100+"],
    descriptionQuestion: "What types of seating were available?",
    descriptionOptions: ["Indoor dining area", "Bar area", "Outdoor dining area", "Booth seating", "Counter seating", "Private dining area"],
    commentPlaceholder: "Tell others about your dining experience"
  },

  // For home contractors and repair services
  homeService: {
    ratingCategories: [
      { key: "overAllRating", label: "Over All Rating" },
   
    ],
    detailSections: [
    
    ],
    tripTypeQuestion: "How would you describe the price you paid? ",
    tripTypeOptions: ["Great Price"  ,"Reasonable Price" ,"Overpriced" ,"Not Sure"],
    descriptionQuestion: "Which services did you get?",
    descriptionOptions: ["Ventilated cieling installation", "HVAC system repair", "HVAC system maintenance", "A/C System Repair", "A/C System Maintenance", "A/C System Installation", "Thermostat Installation"],
    travelWithQuestion: "How much did you spend per person?",
    travelWithOptions: ["$1-100", "$100-200", "$200-300", "$300-400", "$400-500", "$500-600", "$600-700", "$700-800", "$800-900", "$900-1000", "$1000+"],
    commentPlaceholder: "Share your experience"
  },

  // For retail stores
  retail: {
    ratingCategories: [
      { key: "overAllRating", label: "Over All Rating" },
      { key: "productQualityRating", label: "Product Quality" },
      { key: "serviceRating", label: "Customer Service" },
      { key: "valueRating", label: "Value for Money" }
    ],
    detailSections: [
      "Product variety",
      "Store cleanliness",
      "Return policy",
      "Parking"
    ],
    tripTypeQuestion: "What did you purchase?",
    tripTypeOptions: ["Made a purchase", "Just browsing", "Returned an item", "Special order"],
    travelWithQuestion: "How was your shopping experience?",
    travelWithOptions: ["Quick and easy", "Took some time", "Found what I needed", "Didn't find what I needed"],
    descriptionQuestion: "What stood out?",
    descriptionOptions: ["Great selection", "Helpful staff", "Clean store", "Fair prices", "Easy parking", "Fast checkout"],
    commentPlaceholder: "Share your shopping experience"
  },

  // For beauty salons, spas, personal care
  beautySalon: {
    ratingCategories: [
      { key: "overAllRating", label: "Over All Rating" },
    ],
    detailSections: [
      "Requested Style",
      "Specialties",
      "Hair Type",
      "Stylist",
      "Cleanliness"
    ],
    tripTypeQuestion: "",
    tripTypeOptions: [],
    descriptionQuestion: "Which services did you get?",
    descriptionOptions: ["Shampoo & Conditioning", "Hair Threading", "Bridal Services", "Updos", "Blowouts", "Haircut", "Makeup Services", "Hairstyling", "Curly Hair", "Hair Extensions", "Hair Highlighting", "Hair Coloring", "Massage", "Balayage", "Nail Art", "Facial Treatment", "Acrylic Nails", "Gel Manicure", "Pedicure", "Manicure", "Waxing", "Eyelash Extensions", "Dip Powder", "Tattoo", "Piercing"],
    travelWithQuestion: "How much did you spend per person?",
    travelWithOptions: ["$1-50", "$50-100", "$100-150", "$150-200", "$200-250", "$250-300", "$300-350", "$350-400", "$400-450", "$450-500", "$500+"],
    commentPlaceholder: "Share your experience at this salon/spa"
  },

  // For auto services
  autoService: {
    ratingCategories: [
      { key: "overAllRating", label: "Over All Rating" },
      { key: "workQualityRating", label: "Work Quality" },
      { key: "serviceRating", label: "Customer Service" },
      { key: "valueRating", label: "Value for Money" }
    ],
    detailSections: [
      "Timeliness",
      "Communication",
      "Facility cleanliness",
      "Warranty/Guarantee"
    ],
    tripTypeQuestion: "What service did you receive?",
    tripTypeOptions: ["Repair", "Maintenance", "Inspection", "Detailing", "Emergency service"],
    travelWithQuestion: "How long did the service take?",
    travelWithOptions: ["Less than 1 hour", "1-3 hours", "Half day", "Full day", "Multiple days"],
    descriptionQuestion: "What stood out?",
    descriptionOptions: ["Quality work", "Fair pricing", "Quick service", "Honest diagnosis", "Clean facility", "Friendly staff"],
    commentPlaceholder: "Share your experience with this auto service"
  },

  // For professional business services
  

  // For general services (cleaning, pet grooming, etc.)
  generalService: {
    ratingCategories: [
      { key: "overAllRating", label: "Over All Rating" },
      { key: "serviceQualityRating", label: "Service Quality" },
      { key: "professionalismRating", label: "Professionalism" },
      { key: "valueRating", label: "Value for Money" }
    ],
    detailSections: [
      "Reliability",
      "Quality of work",
      "Communication",
      "Cleanliness"
    ],
    tripTypeQuestion: "How often do you use this service?",
    tripTypeOptions: ["First time", "Occasional", "Regular", "One-time need"],
    travelWithQuestion: "How was the scheduling?",
    travelWithOptions: ["Easy to schedule", "Flexible timing", "Limited availability", "Required advance booking"],
    descriptionQuestion: "What did you appreciate?",
    descriptionOptions: ["Professional", "Thorough", "On time", "Fair pricing", "Friendly", "Attention to detail"],
    commentPlaceholder: "Share your experience"
  },

  // Default simple template (fallback)
  simple: {
    ratingCategories: [
      { key: "overAllRating", label: "Over All Rating" }
    ],
    detailSections: [],
    tripTypeQuestion: "",
    tripTypeOptions: [],
    travelWithQuestion: "",
    travelWithOptions: [],
    descriptionQuestion: "",
    descriptionOptions: [],
    commentPlaceholder: "Share your experience"
  }
};

// ============================================
// LAYER 2: Business Type to Template Mapping
// ============================================

export const BUSINESS_TYPE_MAPPING = {
  // HOSPITALITY GROUP (12 types) - All use hotel/hospitality config
  "hotel": "hospitality",
  "motel": "hospitality",
  "extended_stay_hotel": "hospitality",
  "budget_hotel": "hospitality",
  "inn": "hospitality",
  "hostel": "hospitality",
  "resort_hotel": "hospitality",
  "vacation_home_rental_agency": "hospitality",
  "cabin_rental_agency": "hospitality",
  "short_term_apartment_rental_agency": "hospitality",
  "rv_park": "hospitality",
  "campground": "hospitality",

  // ATTORNEY GROUP (11 types) - All use lawyer/attorney config
  "personal_injury_attorney": "simple",
  "workers_compensation_attorney": "simple",
  "criminal_justice_attorney": "simple",
  "immigration_attorney": "simple",
  "family_law_attorney": "simple",
  "divorce_attorney": "simple",
  "bankruptcy_attorney": "simple",
  "estate_planning_attorney": "simple",
  "employment_attorney": "simple",
  "tax_attorney": "simple",
  "social_security_attorney": "simple",

  // HEALTHCARE GROUP (13 types) - All use doctor/healthcare config
  "dentist": "simple",
  "pediatric_dentist": "simple",
  "orthodontist": "simple",
  "periodontist": "simple",
  "emergency_dental_service": "simple",
  "urgent_care_center": "simple",
  "chiropractor": "simple",
  "pain_management_physician": "simple",
  "physical_therapy_clinic": "simple",
  "weight_loss_service": "simple",
  "sleep_clinic": "simple",
  "dermatologist": "simple",
  "veterinarian": "simple",

  // HOME SERVICES/CONTRACTORS GROUP (13 types)
  "hvac_contractor": "homeService",
  "plumber": "homeService",
  "electrician": "homeService",
  "roofing_contractor": "homeService",
  "general_contractor": "simple",
  "foundation_repair_service": "homeService",
  "fence_contractor": "homeService",
  "water_damage_restoration_service": "homeService",
  "pest_control_service": "simple",
  "garage_door_supplier": "simple",
  "solar_energy_contractor": "simple",
  "pool_cleaning_service": "simple",
  "locksmith": "simple",

  // RETAIL/STORES GROUP (10 types)
  "furniture_store": "simple",
  "auto_parts_store": "simple",
  "used_car_dealer": "simple",
  "vape_shop": "simple",
  "pet_supply_store": "simple",
  "cell_phone_store": "simple",
  "mobile_phone_repair_shop": "simple",
  "jewelry_store": "simple",
  "organic_food_store": "simple",
  "medical_supply_store": "simple",

  // RESTAURANT/FOOD GROUP (7 types)
  "indian_restaurant": "restaurant",
  "pizza_restaurant": "restaurant",
  "fast_food_restaurant": "restaurant",
  "cafe": "restaurant",
  "bakery": "restaurant",
  "ice_cream_shop": "restaurant",
  "juice_shop": "restaurant",

  // BEAUTY/SALON GROUP (7 types)
  "beauty_salon": "beautySalon",
  "nail_salon": "beautySalon",
  "hair_salon": "beautySalon",
  "spa": "beautySalon",
  "massage_spa": "beautySalon",
  "barber_shop": "beautySalon",
  "tattoo_shop": "beautySalon",

  // PROFESSIONAL SERVICES GROUP (9 types)
  "marketing_agency": "simple",
  "real_estate_agency": "simple",
  "property_management_company": "simple",
  "accounting_firm": "simple",
  "insurance_agency": "simple",
  "it_support_service": "simple",
  "software_company": "simple",
  "website_designer": "simple",
  "business_consultant": "simple",

  // AUTO SERVICES GROUP (5 types)
  "auto_repair_shop": "simple",
  "auto_body_shop": "simple",
  "car_wash": "simple",
  "car_detailing_service": "simple",
  "towing_service": "simple",

  // GENERAL SERVICES GROUP (remaining types)
  "painting_contractor": "simple",
  "landscaper": "simple",
  "lawn_care_service": "simple",
  "gutter_cleaning_service": "homeService",
  "house_cleaning_service": "simple",
  "dry_cleaner": "simple",
  "flower_shop": "simple",
  "day_care_center": "simple",
  "music_school": "simple",
  "martial_arts_school": "simple",
  "pet_groomer": "simple",
  "logistics_service": "simple",
  "security_guard_service": "simple",
};

// ============================================
// LAYER 3: Custom Overrides for Special Cases
// ============================================

export const BUSINESS_TYPE_OVERRIDES = {
    "plumber": {
        base: "homeService",
        overrides: {
            
            descriptionOptions: ["Toilet Repair", "Water heater installation", "Garbage Disposal Installation", "Shower Installation", "Drain Cleaning", "Plumbing Leak Repair","Faucet Repair", "Sewer cleaning", "Toilet Installation", "Sump Pump Repair", "Service not listed"],
        }
      }
      ,
      "electrician": {
        base: "homeService",
        overrides: {
            descriptionOptions: ["Remodeling", "Fan installation", "Ground wiring installation",  "Electrical wiring installation", "General Repair", "Electrical panel work", "Security system installation", "Electrical car charger installation ", "Electrical wiring repair", "Service not listed"],
        }
      },
      "roofing_contractor": {
        base: "homeService",
        overrides: {
            descriptionOptions: ["Gutter Repair", "Skylight Repair", "Roof Repair", "Roof Inspection", "Gutter Installation", "Attic venting", "Roof Installation", "Skylight Installation", "Roof Damage Repair", "Service not listed"],
        }
      },
      "gutter_cleaning_service": {
        base: "homeService",
        overrides: {
            descriptionOptions: ["Gutter Repair", "Skylight Repair", "Roof Repair", "Roof Inspection", "Gutter Installation", "Attic venting", "Roof Installation", "Skylight Installation", "Roof Damage Repair", "Service not listed"],
        }
      },
      "foundation_repair_service": {
        base: "homeService",
        overrides: {
            descriptionOptions: ["Foundation Repair", "Fence Repair", "Fence Installation", "Fence Replacement", "Fence Inspection",  "Floor installation", "Service not listed"],
        }
      },
      "fence_contractor": {
        base: "homeService",
        overrides: {
            descriptionOptions: ["Foundation Repair", "Fence Repair", "Fence Installation", "Fence Replacement", "Fence Inspection",  "Floor installation", "Service not listed"],
        }
      },
      "water_damage_restoration_service": {
        base: "homeService",
        overrides: {
            
            descriptionOptions: ["Toilet Repair", "Water heater installation", "Garbage Disposal Installation", "Shower Installation", "Drain Cleaning", "Plumbing Leak Repair","Faucet Repair", "Sewer cleaning", "Toilet Installation", "Sump Pump Repair", "Service not listed"],
        }
      }
};

// ============================================
// Main Function to Get Configuration
// ============================================

export const getReviewConfig = (businessType) => {
  if (!businessType) {
    console.warn('No business type provided, using simple template');
    return CONFIG_TEMPLATES.simple;
  }

  // Check for custom override first (LAYER 3)
  const override = BUSINESS_TYPE_OVERRIDES[businessType];
  if (override) {
    const baseConfig = CONFIG_TEMPLATES[override.base];
    return {
      ...baseConfig,
      ...override.overrides,
      // Deep merge arrays if overridden
      ratingCategories: override.overrides.ratingCategories || baseConfig.ratingCategories,
      detailSections: override.overrides.detailSections || baseConfig.detailSections,
      tripTypeOptions: override.overrides.tripTypeOptions || baseConfig.tripTypeOptions,
      travelWithOptions: override.overrides.travelWithOptions || baseConfig.travelWithOptions,
      descriptionOptions: override.overrides.descriptionOptions || baseConfig.descriptionOptions,
    };
  }

  // Check mapping (LAYER 2)
  const templateKey = BUSINESS_TYPE_MAPPING[businessType];
  if (templateKey && CONFIG_TEMPLATES[templateKey]) {
    return CONFIG_TEMPLATES[templateKey];
  }

  // Fallback to simple
  console.warn(`No config found for business type: ${businessType}, using simple template`);
  return CONFIG_TEMPLATES.simple;
};

